import React from "react"

export default function PageTitle({title}) {
  return (
    <div className="text-center text-6xl font-semibold mt-8 mb-8 w-full">{title}</div>
  )
}
